/**
 * TanStack Router: /performance
 *
 * This route file was auto-generated by the route generation script.
 * Component: PerformancePage
 * Layout: Authenticated (_auth)
 *
 * @see scripts/generate-routes.ts
 * @see docs/architecture/tanstack-router-migration-architecture.md
 */
import { createFileRoute } from '@tanstack/react-router'
import PerformancePage from '@/app/performance/page'

/**
 * Route: /performance
 * Layout: _auth (authenticated)
 * Component: PerformancePage
 */
export const Route = createFileRoute('/_auth/performance/')({
  component: PerformancePage,
})
